"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FilterWrapStyled = void 0;

var _uiKit = require("@dbi-tools/ui-kit");

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin: 0 auto 30px;\n  max-width: 430px;\n\n  & > div[role='button'] {\n    flex-grow: 1;\n  }\n  & > select {\n    height: 52px;\n    flex-grow: 1;\n    padding: 0 15px;\n  }\n\n  ", " {\n    padding-left: 9px;\n    padding-right: 9px;\n  }\n  ", " {\n    margin-bottom: 15px;\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var FilterWrapStyled = (0, _uiKit.styled)(_uiKit.Box)(_templateObject(), _uiKit.GridBreakpointsMediaDown.md, _uiKit.GridBreakpointsMediaDown.md);
exports.FilterWrapStyled = FilterWrapStyled;